var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("top"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "image-list" }, [
            _c("img", {
              attrs: { src: require("@/imgs/thumbnail-1.jpg") },
              on: {
                click: function($event) {
                  _vm.showGallery(0)
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticStyle: { color: "red" } }, [
              _vm._v("Tap this picture")
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("gallery", {
            attrs: {
              mediaDatas: _vm.galleryDatas,
              index: _vm.index,
              show: _vm.isShow
            },
            on: {
              onClose: function($event) {
                _vm.isShow = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("bottom")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          staticStyle: { "text-decoration": "underline" },
          attrs: { href: "https://github.com/joel-ou/APopups-Gallery" }
        },
        [_vm._v("Star me if you like")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "doc" }, [
      _c("div", { staticClass: "warning" }, [
        _c("h2", [_vm._v("Before starting")]),
        _vm._v("\n            Before using, you need to know about "),
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("vuejs")]),
        _vm._v(" and "),
        _c("span", { staticStyle: { color: "red" } }, [
          _vm._v("vue's single-file component")
        ]),
        _vm._v(" development\n            "),
        _c("p", { staticStyle: { color: "red" } }, [
          _vm._v(
            "\n                *It is still under testing. Do not use it in production environment\n            "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { color: "red" } }, [
          _vm._v(
            "\n                *** Try not to use it on PC, It's for mobile\n            "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "getting-started" }, [
        _c(
          "a",
          {
            staticClass: "title-h3",
            attrs: { href: "javascript:;", id: "start" }
          },
          [_vm._v("#Getting started")]
        ),
        _vm._v(" "),
        _c("h4", [_vm._v("Step1: install by npm")]),
        _vm._v(" "),
        _c("p", [
          _c("pre", [_c("code", [_vm._v("npm install apopups-gallery -S")])])
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Step2: import gallery vue component")]),
        _vm._v(" "),
        _c("p", [
          _c("pre", [
            _c("code", [
              _vm._v('import gallery from "apopups-gallery";'),
              _c("br")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Step3: Add to vuejs components")]),
        _vm._v(" "),
        _c("p", [
          _c("pre", [_c("code", [_vm._v("components: { gallery }"), _c("br")])])
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Step4: useing gallery component on your vue page")]),
        _vm._v(" "),
        _c("p", [
          _c("pre", [
            _c("code", [
              _vm._v(
                '<gallery :imageDatas="imageDatas" :index="0" :show="isShow" @onClose="isShow=false"></gallery>'
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "title-h3",
            attrs: { href: "javascript:;", id: "parameter" }
          },
          [_vm._v("#Parameter:")]
        ),
        _vm._v(" "),
        _c("table", [
          _c("thead", [
            _c("th", [_vm._v("Name")]),
            _vm._v(" "),
            _c("th", [_vm._v("Type")]),
            _vm._v(" "),
            _c("th", [_vm._v("Required")]),
            _vm._v(" "),
            _c("th", [_vm._v("Description")])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("imageDatas")]),
              _vm._v(" "),
              _c("td", [_vm._v("array")]),
              _vm._v(" "),
              _c("td", [_vm._v("true")]),
              _vm._v(" "),
              _c("td", [_vm._v("The images you want to show")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("index")]),
              _vm._v(" "),
              _c("td", [_vm._v("number")]),
              _vm._v(" "),
              _c("td", [_vm._v("false")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("The index of the images shown starts at 0. "),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v("defualt: 0")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("show")]),
              _vm._v(" "),
              _c("td", [_vm._v("boolean")]),
              _vm._v(" "),
              _c("td", [_vm._v("true")]),
              _vm._v(" "),
              _c("td", [_vm._v("Display and close flags")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("onClose")]),
              _vm._v(" "),
              _c("td", [_vm._v("function")]),
              _vm._v(" "),
              _c("td", [_vm._v("true")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "You must change the show value to false inside the function"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "title-h3",
            attrs: { href: "javascript:;", id: "slots" }
          },
          [_vm._v("#Slots")]
        ),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("galleryBar")]),
          _vm._v(" : Customize your own bottom action bar in the gallery")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }